import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import './index.scss';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Icon from '@salesforce/design-system-react/components/icon';
import Spinner from '@salesforce/design-system-react/components/spinner';
import EventStatusBadge from '../../../Shared/EventStatusBadge';
import { INVENTORY_REQUEST_DETAIL_UI, USAGE_TYPE } from '../../../../util/constants';
import {
  shouldShowSubmissionInFlight,
  SubmissionStatusRecord,
} from '../../../../util/submissionStatus';
import { getSvgIcon } from '../../../../util/utilityFunctions';

interface Status {
  eventStatus: string;
  visualIndicator?: string;
  thresholdQuantityIndicator?: boolean;
  status?: string;
  type?: string;
  checkRejectLineStatus?: boolean;
  submissionStatusRecord?: SubmissionStatusRecord | null;
}
export interface Props {
  children?: FC;
  item?: Status;
}

const InventoryRequestStatusCell: FC<Props> = ({
  item = {
    eventStatus: '',
    visualIndicator: '',
    thresholdQuantityIndicator: '',
    status: '',
    type: '',
    checkRejectLineStatus: '',
    submissionStatusRecord: null,
  },
}) => {
  const {
    eventStatus,
    thresholdQuantityIndicator,
    visualIndicator,
    type,
    checkRejectLineStatus,
    submissionStatusRecord,
  } = item;
  const iconThreshold = getSvgIcon('threshold');
  const isSubmissionInFlight = shouldShowSubmissionInFlight(
    submissionStatusRecord || undefined,
    INVENTORY_REQUEST_DETAIL_UI.SUBMISSION_RECOVERY_MAX_AGE_MS
  );
  return (
    <DataTableCell title={type === USAGE_TYPE.INVENTORY_REQUEST ? eventStatus : visualIndicator || 'NEW'}>
      <div style={{ display: 'flex' }}>
        <EventStatusBadge
          status={type === USAGE_TYPE.INVENTORY_REQUEST ? eventStatus : visualIndicator || 'NEW'}
        />
        {thresholdQuantityIndicator && (
          <div style={{ marginLeft: '5px' }}>
            <img
              className="slds-tooltip-trigger"
              title="Threshold Exceed"
              src={iconThreshold}
              alt="threshold"
              style={{ width: '20px', height: '15px', marginLeft: '5px' }}
            />
          </div>
        )}
        {checkRejectLineStatus && (
          <IconSettings iconPath="/icons">
            <div style={{ marginLeft: '5px' }}>
              <Icon
                title="Rejected"
                category="utility"
                name="warning"
                size="x-small"
                style={{ color: '#b83c27' }}
                className="slds-icon-text-error"
              />
            </div>
          </IconSettings>
        )}
        {isSubmissionInFlight && (
          <div
            title="Submission processing"
            style={{ marginLeft: '5px', display: 'flex', alignItems: 'center' }}
          >
            <Spinner
              size="x-small"
              variant="base"
              assistiveText={{ label: 'Submission processing' }}
              containerStyle={{ position: 'relative', height: '1rem', width: '1rem' }}
            />
          </div>
        )}
      </div>
    </DataTableCell>
  );
};

export default InventoryRequestStatusCell;
